import { useState } from "react";
import { Box, TextField, IconButton, Chip, Tooltip } from "@mui/material";
import { Clear, FilterList } from "@mui/icons-material";
import moment from "moment";

const DateRangeFilter = ({ onFilterChange }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    setStartDate(value);
    onFilterChange({
      startDate: value,
      endDate: endDate
    });
  };

  const handleEndDateChange = (e) => {
    const value = e.target.value;
    setEndDate(value);
    onFilterChange({
      startDate: startDate,
      endDate: value
    });
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    onFilterChange({
      startDate: "",
      endDate: ""
    });
  };

  const hasFilter = startDate || endDate;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1.5,
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: 1,
        borderColor: hasFilter ? 'primary.main' : 'divider',
        transition: 'all 0.2s'
      }}
    >
      <FilterList sx={{ color: hasFilter ? 'primary.main' : 'text.secondary', fontSize: 20 }} />

      <TextField
        type="date"
        label="From"
        value={startDate}
        onChange={handleStartDateChange}
        InputLabelProps={{ shrink: true }}
        size="small"
        sx={{
          minWidth: 140,
          '& .MuiOutlinedInput-root': {
            height: 36,
            fontSize: 13
          }
        }}
      />

      <Box sx={{ color: 'text.secondary', fontSize: 12, fontWeight: 500 }}>to</Box>

      <TextField
        type="date"
        label="To"
        value={endDate}
        onChange={handleEndDateChange}
        InputLabelProps={{ shrink: true }}
        size="small"
        sx={{
          minWidth: 140,
          '& .MuiOutlinedInput-root': {
            height: 36,
            fontSize: 13
          }
        }}
      />

      {hasFilter && (
        <Tooltip title="Clear filter">
          <IconButton onClick={handleClear} size="small" sx={{ ml: 0.5 }}>
            <Clear fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      {hasFilter && (
        <Chip
          label="Filtered"
          size="small"
          color="primary"
          sx={{ fontSize: 10, height: 20, ml: 0.5 }}
        />
      )}
    </Box>
  );
};

export default DateRangeFilter;
